export default "__VITE_ASSET__DZRIM89g__"